import React, { memo } from "react";
import { Box, VStack } from '@chakra-ui/react'
import { CouponImg } from "./CouponImg";
import { PageTransitionBtn } from "../../atoms/button/PageTransitionBtn";
import { DefaultBenefitDesign } from "./DefaultBenefitDesign";

type BenefitCardProps = {
  id: string;
  title: string;
  img: string | null;
}

export const BenefitCard: React.FC<BenefitCardProps> = memo(({id, title, img}) => {

  return (
    <VStack spacing={1}>
      <Box h='45.8vw' w='100%'>
        {img ? <CouponImg img={img} /> : <DefaultBenefitDesign title={title} />}
      </Box>
      <PageTransitionBtn path={`/membership/customer-benefits/${id}`} text='サービスを表示' />
    </VStack>
    );
});
